<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="医生ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['doctorId', validatorRules.doctorId]" placeholder="请输入医生ID"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="流水ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['doctorAccountFlowId', validatorRules.doctorAccountFlowId]" placeholder="请输入流水ID"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="提现金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['amount', validatorRules.amount]" placeholder="请输入提现金额" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="创建时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择创建时间" v-decorator="['createTime', validatorRules.createTime]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="创建人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['createBy', validatorRules.createBy]" placeholder="请输入创建人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="状态  0 申请中  1 已审批  2 已拒绝" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['status', validatorRules.status]" placeholder="请输入状态  0 申请中  1 已审批  2 已拒绝" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@comp/jeecg/JFormContainer'
  import JDate from '@comp/jeecg/JDate'
  // import WithdrawRecordModal from './WithdrawRecordModal'

  export default {
    name: 'WithdrawRecordForm',
    components: {
      // WithdrawRecordModa,
      JFormContainer,
      JDate,

    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
validatorRules: {
        doctorId: {
        rules: [
            { required: true, message: '请输入医生ID!'},
        ]
        },
        doctorAccountFlowId: {
        rules: [
            { required: true, message: '请输入流水ID!'},
        ]
        },
        amount: {
        rules: [
            { required: true, message: '请输入提现金额!'},
        ]
        },
        createTime: {
        rules: [
            { required: true, message: '请输入创建时间!'},
        ]
        },
        createBy: {
        rules: [
            { required: true, message: '请输入创建人!'},
        ]
        },
        status: {
        rules: [
            { required: true, message: '请输入状态  0 申请中  1 已审批  2 已拒绝!'},
        ]
        },
},
        url: {
          add: "/carry/withdrawRecord/add",
          edit: "/carry/withdrawRecord/edit",
          queryById: "/carry/withdrawRecord/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'doctorId','doctorAccountFlowId','amount','createTime','createBy','status','reason'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'doctorId','doctorAccountFlowId','amount','createTime','createBy','status'))
      },
    }
  }
</script>